import React, { Component } from "react";
import { Spin, Select, message } from "antd";
import Bridge from "../../../../constants/Bridge";
import moment from "moment";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import Strings from "../../../../constants/Strings";

const { Option } = Select;
export default class Cumulative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      export_button_loader: false,
      current_year: moment().format("YYYY"),
      graphData: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        datasets: [
          {
            type: "bar",
            label: "Enrolled",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            backgroundColor: "#4285f5", // Bar fill color
            borderColor: "#4285f5", // Bar border color
            borderWidth: 1,
          },
          {
            type: "line",
            label: "Active",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            borderColor: "#34785c", // Line color
            backgroundColor: "#c3d6bc", // Bar fill color
            borderWidth: 2,
            fill: true, // Disable fill for line dataset
          },
          {
            type: "line",
            label: "Withdrawn",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            borderColor: "#f80303", // Line color
            backgroundColor: "#d39683",
            borderWidth: 2,
            fill: true, // Disable fill for line dataset
          },
        ],
      },
      loader: false,
      selected_year: "2023",
      year_list: [],
      records: [],
    };
  }
  componentDidMount() {
    this.get_radcliff_enrollment_data();
    this.get_year_list();
    Chart.register(ChartDataLabels);
  }
  get_year_list = () => {
    function getYearsUpToCurrentDate(startYear) {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = startYear; year <= currentYear; year++) {
        years.push(year);
      }
      return years;
    }
    const startYear = 2022; // Change this to your desired starting year
    const yearsList = getYearsUpToCurrentDate(startYear);
    this.setState({
      year_list: yearsList,
    });
  };
  // get enrollment data
  get_radcliff_enrollment_data = () => {
    this.setState({ loader: true });
    let params = "?year=" + this.state.selected_year;
    Bridge.radcliff_study
      .get_cumulative_chart_data()
      .then((res) => {
        if (res.status == "1") {
          this.setState(
            {
              records: res.data,
            },
            () => this.setGraphData()
          );
          this.setState({ loader: false });
        } else {
          this.setState({ loader: false });
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
      });
  };
  setGraphData = () => {
    let selected_year = this.state.selected_year;
    this.setState({ loader: true });
    let enrolled_list = this.state.records.enrolled;
    let withdrawn_list = this.state.records.withdrawn;
    let session_entry = this.state.records.session_entry;
    let self_report = this.state.records.self_report;
    let enrolled_list_count = this.get_formatted_enrolled_list(
      enrolled_list,
      selected_year
    );
    let withdrawn_list_count = this.get_formatted_withdrawn_list(
      withdrawn_list,
      selected_year
    );
    let session_data = this.format_active_participant_data(
      session_entry,
      self_report,
      selected_year
    );
    let current_year = moment().format("YYYY");
    let current_month = moment().format("MM");
    let labels = [];
    if (selected_year == current_year) {
      if (Number(current_month) > 0) {
        labels.push("January");
      }
      if (Number(current_month) > 1) {
        labels.push("February");
      }
      if (Number(current_month) > 2) {
        labels.push("March");
      }
      if (Number(current_month) > 3) {
        labels.push("April");
      }
      if (Number(current_month) > 4) {
        labels.push("May");
      }
      if (Number(current_month) > 5) {
        labels.push("June");
      }
      if (Number(current_month) > 6) {
        labels.push("July");
      }
      if (Number(current_month) > 7) {
        labels.push("August");
      }
      if (Number(current_month) > 8) {
        labels.push("September");
      }
      if (Number(current_month) > 9) {
        labels.push("October");
      }
      if (Number(current_month) > 10) {
        labels.push("November");
      }
      if (Number(current_month) > 11) {
        labels.push("December");
      }
    } else {
      labels = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
    }
    labels = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let data2 = {
      labels: labels,
      datasets: [
        {
          type: "bar",
          label: "Enrolled",
          data: enrolled_list_count,
          backgroundColor: "rgba(75, 192, 192, 0.2)", // Bar fill color
          borderColor: "#4285f5", // Bar border color
          borderWidth: 1,
          zIndex: -1,
        },
        {
          type: "line",
          label: "Active",
          data: session_data,
          borderColor: "rgba(78, 127, 55,1)", // Line color
          backgroundColor: "rgba(78, 127, 55,0.2)", // Bar fill color
          borderWidth: 3,
          fill: true, // Disable fill for line dataset
          tension: 0.1,
        },
        {
          type: "line",
          label: "Withdrawn",
          data: withdrawn_list_count,
          borderColor: "#f80303", // Line color
          backgroundColor: "rgba(248,3,3,0.22)",
          borderWidth: 2,
          fill: true, // Disable fill for line dataset
        },
      ],
    };
    this.setState({
      graphData: data2,
      loader: false,
    });
  };

  get_formatted_withdrawn_list = (list, selected_year) => {
    let duplicate = [];
    let partcpnt_upto_jan = [];
    let partcpnt_upto_feb = [];
    let partcpnt_upto_mar = [];
    let partcpnt_upto_apr = [];
    let partcpnt_upto_may = [];
    let partcpnt_upto_jun = [];
    let partcpnt_upto_jul = [];
    let partcpnt_upto_aug = [];
    let partcpnt_upto_sep = [];
    let partcpnt_upto_oct = [];
    let partcpnt_upto_nov = [];
    let partcpnt_upto_dec = [];
    let current_month = moment().format("MM");
    let jan_date = new Date(selected_year + "-01-31");
    let feb_date = new Date(selected_year + "-02-28");
    let mar_date = new Date(selected_year + "-03-31");
    let apr_date = new Date(selected_year + "-04-30");
    let may_date = new Date(selected_year + "-05-31");
    let jun_date = new Date(selected_year + "-06-30");
    let jul_date = new Date(selected_year + "-07-31");
    let aug_date = new Date(selected_year + "-08-31");
    let sep_date = new Date(selected_year + "-09-30");
    let oct_date = new Date(selected_year + "-10-31");
    let nov_date = new Date(selected_year + "-11-30");
    let dec_date = new Date(selected_year + "-12-31");
    for (let item of list) {
      let year = moment(item.dropped_out_date).format("YYYY");
      // if (year == selected_year) {
      let month = moment(item.dropped_out_date).format("MM");
      let enrolled_date = moment(item.dropped_out_date).format("YYYY-MM-DD");
      enrolled_date = new Date(enrolled_date);
      let dtext = item.participants_id + "-" + month;
      if (!duplicate.includes(dtext)) {
        if (this.state.current_year == selected_year) {
          if (
            (enrolled_date.getTime() < jan_date.getTime() ||
              enrolled_date.getTime() == jan_date.getTime()) &&
            Number(current_month) > 0
          ) {
            partcpnt_upto_jan.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < feb_date.getTime() ||
              enrolled_date.getTime() == feb_date.getTime()) &&
            Number(current_month) > 1
          ) {
            partcpnt_upto_feb.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < mar_date.getTime() ||
              enrolled_date.getTime() == mar_date.getTime()) &&
            Number(current_month) > 2
          ) {
            partcpnt_upto_mar.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < apr_date.getTime() ||
              enrolled_date.getTime() == apr_date.getTime()) &&
            Number(current_month) > 3
          ) {
            partcpnt_upto_apr.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < may_date.getTime() ||
              enrolled_date.getTime() == may_date.getTime()) &&
            Number(current_month) > 4
          ) {
            partcpnt_upto_may.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < jun_date.getTime() ||
              enrolled_date.getTime() == jun_date.getTime()) &&
            Number(current_month) > 5
          ) {
            partcpnt_upto_jun.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < jul_date.getTime() ||
              enrolled_date.getTime() == jul_date.getTime()) &&
            Number(current_month) > 6
          ) {
            partcpnt_upto_jul.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < aug_date.getTime() ||
              enrolled_date.getTime() == aug_date.getTime()) &&
            Number(current_month) > 7
          ) {
            partcpnt_upto_aug.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < sep_date.getTime() ||
              enrolled_date.getTime() == sep_date.getTime()) &&
            Number(current_month) > 8
          ) {
            partcpnt_upto_sep.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < oct_date.getTime() ||
              enrolled_date.getTime() == oct_date.getTime()) &&
            Number(current_month) > 9
          ) {
            partcpnt_upto_oct.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < nov_date.getTime() ||
              enrolled_date.getTime() == nov_date.getTime()) &&
            Number(current_month) > 10
          ) {
            partcpnt_upto_nov.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < dec_date.getTime() ||
              enrolled_date.getTime() == dec_date.getTime()) &&
            Number(current_month) > 11
          ) {
            partcpnt_upto_dec.push(item.participants_id);
          }
        } else {
          if (
            enrolled_date.getTime() < jan_date.getTime() ||
            enrolled_date.getTime() == jan_date.getTime()
          ) {
            partcpnt_upto_jan.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < feb_date.getTime() ||
            enrolled_date.getTime() == feb_date.getTime()
          ) {
            partcpnt_upto_feb.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < mar_date.getTime() ||
            enrolled_date.getTime() == mar_date.getTime()
          ) {
            partcpnt_upto_mar.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < apr_date.getTime() ||
            enrolled_date.getTime() == apr_date.getTime()
          ) {
            partcpnt_upto_apr.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < may_date.getTime() ||
            enrolled_date.getTime() == may_date.getTime()
          ) {
            partcpnt_upto_may.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < jun_date.getTime() ||
            enrolled_date.getTime() == jun_date.getTime()
          ) {
            partcpnt_upto_jun.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < jul_date.getTime() ||
            enrolled_date.getTime() == jul_date.getTime()
          ) {
            partcpnt_upto_jul.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < aug_date.getTime() ||
            enrolled_date.getTime() == aug_date.getTime()
          ) {
            partcpnt_upto_aug.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < sep_date.getTime() ||
            enrolled_date.getTime() == sep_date.getTime()
          ) {
            partcpnt_upto_sep.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < oct_date.getTime() ||
            enrolled_date.getTime() == oct_date.getTime()
          ) {
            partcpnt_upto_oct.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < nov_date.getTime() ||
            enrolled_date.getTime() == nov_date.getTime()
          ) {
            partcpnt_upto_nov.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < dec_date.getTime() ||
            enrolled_date.getTime() == dec_date.getTime()
          ) {
            partcpnt_upto_dec.push(item.participants_id);
          }
        }
        duplicate.push(dtext);
      }
      // }
    }
    let jan_unique = [...new Set(partcpnt_upto_jan)];
    let feb_unique = [...new Set(partcpnt_upto_feb)];
    let mar_unique = [...new Set(partcpnt_upto_mar)];
    let apr_unique = [...new Set(partcpnt_upto_apr)];
    let may_unique = [...new Set(partcpnt_upto_may)];
    let jun_unique = [...new Set(partcpnt_upto_jun)];
    let jul_unique = [...new Set(partcpnt_upto_jul)];
    let aug_unique = [...new Set(partcpnt_upto_aug)];
    let sep_unique = [...new Set(partcpnt_upto_sep)];
    let oct_unique = [...new Set(partcpnt_upto_oct)];
    let nov_unique = [...new Set(partcpnt_upto_nov)];
    let dec_unique = [...new Set(partcpnt_upto_dec)];

    let withdawn_participant_count = [
      jan_unique.length,
      feb_unique.length,
      mar_unique.length,
      apr_unique.length,
      may_unique.length,
      jun_unique.length,
      jul_unique.length,
      aug_unique.length,
      sep_unique.length,
      oct_unique.length,
      nov_unique.length,
      dec_unique.length,
    ];
    return withdawn_participant_count;
  };
  get_formatted_enrolled_list = (list, selected_year) => {
    let duplicate = [];
    let partcpnt_upto_jan = [];
    let partcpnt_upto_feb = [];
    let partcpnt_upto_mar = [];
    let partcpnt_upto_apr = [];
    let partcpnt_upto_may = [];
    let partcpnt_upto_jun = [];
    let partcpnt_upto_jul = [];
    let partcpnt_upto_aug = [];
    let partcpnt_upto_sep = [];
    let partcpnt_upto_oct = [];
    let partcpnt_upto_nov = [];
    let partcpnt_upto_dec = [];
    let jan_date = new Date(selected_year + "-01-31");
    let feb_date = new Date(selected_year + "-02-28");
    let mar_date = new Date(selected_year + "-03-31");
    let apr_date = new Date(selected_year + "-04-30");
    let may_date = new Date(selected_year + "-05-31");
    let jun_date = new Date(selected_year + "-06-30");
    let jul_date = new Date(selected_year + "-07-31");
    let aug_date = new Date(selected_year + "-08-31");
    let sep_date = new Date(selected_year + "-09-30");
    let oct_date = new Date(selected_year + "-10-31");
    let nov_date = new Date(selected_year + "-11-30");
    let dec_date = new Date(selected_year + "-12-31");
    let current_month = moment().format("MM");
    for (let item of list) {
      let year = moment(item.date_created.split("T")[0]).format("YYYY");
      // if (year == selected_year) {
      let month = moment(item.date_created.split("T")[0]).format("MM");
      let enrolled_date = moment(item.date_created.split("T")[0]).format(
        "YYYY-MM-DD"
      );

      enrolled_date = new Date(enrolled_date);
      let dtext = item.participants_id + "-" + month;
      if (!duplicate.includes(dtext)) {
        if (this.state.current_year == selected_year) {
          if (
            (enrolled_date.getTime() < jan_date.getTime() ||
              enrolled_date.getTime() == jan_date.getTime()) &&
            Number(current_month) > 0
          ) {
            partcpnt_upto_jan.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < feb_date.getTime() ||
              enrolled_date.getTime() == feb_date.getTime()) &&
            Number(current_month) > 1
          ) {
            partcpnt_upto_feb.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < mar_date.getTime() ||
              enrolled_date.getTime() == mar_date.getTime()) &&
            Number(current_month) > 2
          ) {
            partcpnt_upto_mar.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < apr_date.getTime() ||
              enrolled_date.getTime() == apr_date.getTime()) &&
            Number(current_month) > 3
          ) {
            partcpnt_upto_apr.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < may_date.getTime() ||
              enrolled_date.getTime() == may_date.getTime()) &&
            Number(current_month) > 4
          ) {
            partcpnt_upto_may.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < jun_date.getTime() ||
              enrolled_date.getTime() == jun_date.getTime()) &&
            Number(current_month) > 5
          ) {
            partcpnt_upto_jun.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < jul_date.getTime() ||
              enrolled_date.getTime() == jul_date.getTime()) &&
            Number(current_month) > 6
          ) {
            partcpnt_upto_jul.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < aug_date.getTime() ||
              enrolled_date.getTime() == aug_date.getTime()) &&
            Number(current_month) > 7
          ) {
            partcpnt_upto_aug.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < sep_date.getTime() ||
              enrolled_date.getTime() == sep_date.getTime()) &&
            Number(current_month) > 8
          ) {
            partcpnt_upto_sep.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < oct_date.getTime() ||
              enrolled_date.getTime() == oct_date.getTime()) &&
            Number(current_month) > 9
          ) {
            partcpnt_upto_oct.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < nov_date.getTime() ||
              enrolled_date.getTime() == nov_date.getTime()) &&
            Number(current_month) > 10
          ) {
            partcpnt_upto_nov.push(item.participants_id);
          }
          if (
            (enrolled_date.getTime() < dec_date.getTime() ||
              enrolled_date.getTime() == dec_date.getTime()) &&
            Number(current_month) > 11
          ) {
            partcpnt_upto_dec.push(item.participants_id);
          }
          duplicate.push(dtext);
        } else {
          if (
            enrolled_date.getTime() < jan_date.getTime() ||
            enrolled_date.getTime() == jan_date.getTime()
          ) {
            partcpnt_upto_jan.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < feb_date.getTime() ||
            enrolled_date.getTime() == feb_date.getTime()
          ) {
            partcpnt_upto_feb.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < mar_date.getTime() ||
            enrolled_date.getTime() == mar_date.getTime()
          ) {
            partcpnt_upto_mar.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < apr_date.getTime() ||
            enrolled_date.getTime() == apr_date.getTime()
          ) {
            partcpnt_upto_apr.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < may_date.getTime() ||
            enrolled_date.getTime() == may_date.getTime()
          ) {
            partcpnt_upto_may.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < jun_date.getTime() ||
            enrolled_date.getTime() == jun_date.getTime()
          ) {
            partcpnt_upto_jun.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < jul_date.getTime() ||
            enrolled_date.getTime() == jul_date.getTime()
          ) {
            partcpnt_upto_jul.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < aug_date.getTime() ||
            enrolled_date.getTime() == aug_date.getTime()
          ) {
            partcpnt_upto_aug.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < sep_date.getTime() ||
            enrolled_date.getTime() == sep_date.getTime()
          ) {
            partcpnt_upto_sep.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < oct_date.getTime() ||
            enrolled_date.getTime() == oct_date.getTime()
          ) {
            partcpnt_upto_oct.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < nov_date.getTime() ||
            enrolled_date.getTime() == nov_date.getTime()
          ) {
            partcpnt_upto_nov.push(item.participants_id);
          }
          if (
            enrolled_date.getTime() < dec_date.getTime() ||
            enrolled_date.getTime() == dec_date.getTime()
          ) {
            partcpnt_upto_dec.push(item.participants_id);
          }
          duplicate.push(dtext);
        }
      }
      // }
    }
    let jan_unique = [...new Set(partcpnt_upto_jan)];
    let feb_unique = [...new Set(partcpnt_upto_feb)];
    let mar_unique = [...new Set(partcpnt_upto_mar)];
    let apr_unique = [...new Set(partcpnt_upto_apr)];
    let may_unique = [...new Set(partcpnt_upto_may)];
    let jun_unique = [...new Set(partcpnt_upto_jun)];
    let jul_unique = [...new Set(partcpnt_upto_jul)];
    let aug_unique = [...new Set(partcpnt_upto_aug)];
    let sep_unique = [...new Set(partcpnt_upto_sep)];
    let oct_unique = [...new Set(partcpnt_upto_oct)];
    let nov_unique = [...new Set(partcpnt_upto_nov)];
    let dec_unique = [...new Set(partcpnt_upto_dec)];

    let enrolled_participant_count = [
      jan_unique.length,
      feb_unique.length,
      mar_unique.length,
      apr_unique.length,
      may_unique.length,
      jun_unique.length,
      jul_unique.length,
      aug_unique.length,
      sep_unique.length,
      oct_unique.length,
      nov_unique.length,
      dec_unique.length,
    ];
    return enrolled_participant_count;
  };
  format_active_participant_data = (
    session_entry,
    self_reports,
    selected_year
  ) => {
    let duplicate = [];
    let partcpnt_upto_jan = [];
    let partcpnt_upto_feb = [];
    let partcpnt_upto_mar = [];
    let partcpnt_upto_apr = [];
    let partcpnt_upto_may = [];
    let partcpnt_upto_jun = [];
    let partcpnt_upto_jul = [];
    let partcpnt_upto_aug = [];
    let partcpnt_upto_sep = [];
    let partcpnt_upto_oct = [];
    let partcpnt_upto_nov = [];
    let partcpnt_upto_dec = [];
    let jan_date = new Date(selected_year + "-01-31");
    let feb_date = new Date(selected_year + "-02-28");
    let mar_date = new Date(selected_year + "-03-31");
    let apr_date = new Date(selected_year + "-04-30");
    let may_date = new Date(selected_year + "-05-31");
    let jun_date = new Date(selected_year + "-06-30");
    let jul_date = new Date(selected_year + "-07-31");
    let aug_date = new Date(selected_year + "-08-31");
    let sep_date = new Date(selected_year + "-09-30");
    let oct_date = new Date(selected_year + "-10-31");
    let nov_date = new Date(selected_year + "-11-30");
    let dec_date = new Date(selected_year + "-12-31");
    let current_month = moment().format("MM");
    let current_year = moment().format("YYYY");
    for (let item of session_entry) {
      let year = moment(item.entry_date).format("YYYY");
      if (year == selected_year) {
        let month = moment(item.entry_date).format("MM");
        let session_completed_date = moment(item.entry_date).format(
          "YYYY-MM-DD"
        );
        session_completed_date = new Date(session_completed_date);
        let dtext = item.participants_id + "-" + month;
        if (!duplicate.includes(dtext)) {
          if (current_year == selected_year) {
            if (
              (session_completed_date.getTime() < jan_date.getTime() ||
                session_completed_date.getTime() == jan_date.getTime()) &&
              Number(current_month) > 0
            ) {
              partcpnt_upto_jan.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < feb_date.getTime() ||
                session_completed_date.getTime() == feb_date.getTime()) &&
              Number(current_month) > 1
            ) {
              partcpnt_upto_feb.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < mar_date.getTime() ||
                session_completed_date.getTime() == mar_date.getTime()) &&
              Number(current_month) > 2
            ) {
              partcpnt_upto_mar.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < apr_date.getTime() ||
                session_completed_date.getTime() == apr_date.getTime()) &&
              Number(current_month) > 3
            ) {
              partcpnt_upto_apr.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < may_date.getTime() ||
                session_completed_date.getTime() == may_date.getTime()) &&
              Number(current_month) > 4
            ) {
              partcpnt_upto_may.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < jun_date.getTime() ||
                session_completed_date.getTime() == jun_date.getTime()) &&
              Number(current_month) > 5
            ) {
              partcpnt_upto_jun.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < jul_date.getTime() ||
                session_completed_date.getTime() == jul_date.getTime()) &&
              Number(current_month) > 6
            ) {
              partcpnt_upto_jul.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < aug_date.getTime() ||
                session_completed_date.getTime() == aug_date.getTime()) &&
              Number(current_month) > 7
            ) {
              partcpnt_upto_aug.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < sep_date.getTime() ||
                session_completed_date.getTime() == sep_date.getTime()) &&
              Number(current_month) > 8
            ) {
              partcpnt_upto_sep.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < oct_date.getTime() ||
                session_completed_date.getTime() == oct_date.getTime()) &&
              Number(current_month) > 9
            ) {
              partcpnt_upto_oct.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < nov_date.getTime() ||
                session_completed_date.getTime() == nov_date.getTime()) &&
              Number(current_month) > 10
            ) {
              partcpnt_upto_nov.push(item.participants_id);
            }
            if (
              (session_completed_date.getTime() < dec_date.getTime() ||
                session_completed_date.getTime() == dec_date.getTime()) &&
              Number(current_month) > 11
            ) {
              partcpnt_upto_dec.push(item.participants_id);
            }
          } else {
            if (
              session_completed_date.getTime() < jan_date.getTime() ||
              session_completed_date.getTime() == jan_date.getTime()
            ) {
              partcpnt_upto_jan.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < feb_date.getTime() ||
              session_completed_date.getTime() == feb_date.getTime()
            ) {
              partcpnt_upto_feb.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < mar_date.getTime() ||
              session_completed_date.getTime() == mar_date.getTime()
            ) {
              partcpnt_upto_mar.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < apr_date.getTime() ||
              session_completed_date.getTime() == apr_date.getTime()
            ) {
              partcpnt_upto_apr.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < may_date.getTime() ||
              session_completed_date.getTime() == may_date.getTime()
            ) {
              partcpnt_upto_may.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < jun_date.getTime() ||
              session_completed_date.getTime() == jun_date.getTime()
            ) {
              partcpnt_upto_jun.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < jul_date.getTime() ||
              session_completed_date.getTime() == jul_date.getTime()
            ) {
              partcpnt_upto_jul.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < aug_date.getTime() ||
              session_completed_date.getTime() == aug_date.getTime()
            ) {
              partcpnt_upto_aug.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < sep_date.getTime() ||
              session_completed_date.getTime() == sep_date.getTime()
            ) {
              partcpnt_upto_sep.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < oct_date.getTime() ||
              session_completed_date.getTime() == oct_date.getTime()
            ) {
              partcpnt_upto_oct.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < nov_date.getTime() ||
              session_completed_date.getTime() == nov_date.getTime()
            ) {
              partcpnt_upto_nov.push(item.participants_id);
            }
            if (
              session_completed_date.getTime() < dec_date.getTime() ||
              session_completed_date.getTime() == dec_date.getTime()
            ) {
              partcpnt_upto_dec.push(item.participants_id);
            }
          }
          duplicate.push(dtext);
        }
      }
    }
    for (let item of self_reports) {
      let year = moment(item.entry_date).format("YYYY");
      // if (year == selected_year) {
      let month = moment(item.entry_date).format("MM");
      let session_completed_date = moment(item.entry_date).format("YYYY-MM-DD");
      session_completed_date = new Date(session_completed_date);
      let dtext = item.participants_id + "-" + month;
      if (!duplicate.includes(dtext)) {
        if (current_year == selected_year) {
          if (
            (session_completed_date.getTime() < jan_date.getTime() ||
              session_completed_date.getTime() == jan_date.getTime()) &&
            Number(current_month) > 0
          ) {
            partcpnt_upto_jan.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < feb_date.getTime() ||
              session_completed_date.getTime() == feb_date.getTime()) &&
            Number(current_month) > 1
          ) {
            partcpnt_upto_feb.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < mar_date.getTime() ||
              session_completed_date.getTime() == mar_date.getTime()) &&
            Number(current_month) > 2
          ) {
            partcpnt_upto_mar.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < apr_date.getTime() ||
              session_completed_date.getTime() == apr_date.getTime()) &&
            Number(current_month) > 3
          ) {
            partcpnt_upto_apr.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < may_date.getTime() ||
              session_completed_date.getTime() == may_date.getTime()) &&
            Number(current_month) > 4
          ) {
            partcpnt_upto_may.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < jun_date.getTime() ||
              session_completed_date.getTime() == jun_date.getTime()) &&
            Number(current_month) > 5
          ) {
            partcpnt_upto_jun.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < jul_date.getTime() ||
              session_completed_date.getTime() == jul_date.getTime()) &&
            Number(current_month) > 6
          ) {
            partcpnt_upto_jul.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < aug_date.getTime() ||
              session_completed_date.getTime() == aug_date.getTime()) &&
            Number(current_month) > 7
          ) {
            partcpnt_upto_aug.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < sep_date.getTime() ||
              session_completed_date.getTime() == sep_date.getTime()) &&
            Number(current_month) > 8
          ) {
            partcpnt_upto_sep.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < oct_date.getTime() ||
              session_completed_date.getTime() == oct_date.getTime()) &&
            Number(current_month) > 9
          ) {
            partcpnt_upto_oct.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < nov_date.getTime() ||
              session_completed_date.getTime() == nov_date.getTime()) &&
            Number(current_month) > 10
          ) {
            partcpnt_upto_nov.push(item.participants_id);
          }
          if (
            (session_completed_date.getTime() < dec_date.getTime() ||
              session_completed_date.getTime() == dec_date.getTime()) &&
            Number(current_month) > 11
          ) {
            partcpnt_upto_dec.push(item.participants_id);
          }
        } else {
          if (
            session_completed_date.getTime() < jan_date.getTime() ||
            session_completed_date.getTime() == jan_date.getTime()
          ) {
            partcpnt_upto_jan.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < feb_date.getTime() ||
            session_completed_date.getTime() == feb_date.getTime()
          ) {
            partcpnt_upto_feb.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < mar_date.getTime() ||
            session_completed_date.getTime() == mar_date.getTime()
          ) {
            partcpnt_upto_mar.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < apr_date.getTime() ||
            session_completed_date.getTime() == apr_date.getTime()
          ) {
            partcpnt_upto_apr.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < may_date.getTime() ||
            session_completed_date.getTime() == may_date.getTime()
          ) {
            partcpnt_upto_may.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < jun_date.getTime() ||
            session_completed_date.getTime() == jun_date.getTime()
          ) {
            partcpnt_upto_jun.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < jul_date.getTime() ||
            session_completed_date.getTime() == jul_date.getTime()
          ) {
            partcpnt_upto_jul.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < aug_date.getTime() ||
            session_completed_date.getTime() == aug_date.getTime()
          ) {
            partcpnt_upto_aug.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < sep_date.getTime() ||
            session_completed_date.getTime() == sep_date.getTime()
          ) {
            partcpnt_upto_sep.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < oct_date.getTime() ||
            session_completed_date.getTime() == oct_date.getTime()
          ) {
            partcpnt_upto_oct.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < nov_date.getTime() ||
            session_completed_date.getTime() == nov_date.getTime()
          ) {
            partcpnt_upto_nov.push(item.participants_id);
          }
          if (
            session_completed_date.getTime() < dec_date.getTime() ||
            session_completed_date.getTime() == dec_date.getTime()
          ) {
            partcpnt_upto_dec.push(item.participants_id);
          }
        }

        duplicate.push(dtext);
      }
      // }
    }
    let jan_unique = [...new Set(partcpnt_upto_jan)];
    let feb_unique = [...new Set(partcpnt_upto_feb)];
    let mar_unique = [...new Set(partcpnt_upto_mar)];
    let apr_unique = [...new Set(partcpnt_upto_apr)];
    let may_unique = [...new Set(partcpnt_upto_may)];
    let jun_unique = [...new Set(partcpnt_upto_jun)];
    let jul_unique = [...new Set(partcpnt_upto_jul)];
    let aug_unique = [...new Set(partcpnt_upto_aug)];
    let sep_unique = [...new Set(partcpnt_upto_sep)];
    let oct_unique = [...new Set(partcpnt_upto_oct)];
    let nov_unique = [...new Set(partcpnt_upto_nov)];
    let dec_unique = [...new Set(partcpnt_upto_dec)];

    let active_participant_count = [
      jan_unique.length,
      feb_unique.length,
      mar_unique.length,
      apr_unique.length,
      may_unique.length,
      jun_unique.length,
      jul_unique.length,
      aug_unique.length,
      sep_unique.length,
      oct_unique.length,
      nov_unique.length,
      dec_unique.length,
    ];
    return active_participant_count;
  };
  onChangeSelectedYear = (value) => {
    this.setState(
      {
        selected_year: value,
      },
      () => this.get_radcliff_enrollment_data()
    );
  };
  render() {
    const data = {
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      datasets: [
        {
          type: "bar",
          label: "Enrolled",
          data: [12, 19, 3, 5, 2, 5, 33, 5, 3, 5, 4, 7],
          backgroundColor: "#4285f5", // Bar fill color
          borderColor: "#4285f5", // Bar border color
          borderWidth: 1,
        },
        {
          type: "line",
          label: "Active",
          data: [8, 10, 6, 4, 7, 3, 5, 7, 3, 6, 8, 4],
          borderColor: "#34785c", // Line color
          backgroundColor: "#c3d6bc", // Bar fill color
          borderWidth: 2,
          fill: true, // Disable fill for line dataset
        },
        {
          type: "line",
          label: "Withdrawn",
          data: [2, 3, 2, 23, 2, 22, 5, 3, 2, 32, 1, 2],
          borderColor: "#f80303", // Line color
          backgroundColor: "#d39683",
          borderWidth: 2,
          fill: true, // Disable fill for line dataset
        },
      ],
    };
    const graphStyle = {
      background: "#fff",
      paddingBottom: 20,
      paddingLeft: 31,
      paddingTop: 15,
    };
    const options = {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
      plugins: {
        datalabels: {
          display: true,
          color: "black",
          formatter: Math.round,
          anchor: "end",
          // offset: -20,
          align: "start",
          offset: function (context) {
            console.log("context", context);
            // Define different offsets for each dataset
            const datasetIndex = context.datasetIndex;
            if (datasetIndex === 0) {
              return -0;
            } else if (datasetIndex === 1) {
              return -20;
            } else if (datasetIndex === 2) {
              return -20;
            }
            // return datasetIndex === 0 ? 4 : 10; // Example offsets for datasets
          },
        },
      },
      legend: {
        display: false,
      },
    };
    const paraStyle = {
      textAlign: "center",
      paddingBottom: 20,
      paddingTop: 10,
      fontSize: 17,
      fontWeight: "600",
    };
    const yAxisLabelStyle = {
      position: "absolute",
      left: -115,
      top: -105,
    };
    const yRotate = {
      position: "absolute",
      height: 50,
      width: 203,
      rotate: "270deg",
      fontSize: 16,
      color: "#000",
      fontWeight: "600",
    };

    return (
      <div>
        <div className="d-flex">
          <h2 style={{ color: "#000", fontWeight: "600" }}>
            {Strings.radcliffCumulative}
          </h2>
        </div>
        <br />
        <div
          className="form-group"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "column",
            width: "fit-content",
            textAlign: "left",
          }}
        >
          <label>Year</label>
          <Select
            onChange={this.onChangeSelectedYear}
            value={this.state.selected_year}
            style={{
              minWidth: 220,
              marginBottom: 23,
            }}
            className="cumulative-select-year"
          >
            <Option value="">Select Year</Option>
            {this.state.year_list &&
              this.state.year_list.map((item, index) => {
                return <Option value={item}>{item}</Option>;
              })}
          </Select>
          <br />
        </div>
        <div id="radcliff_cumulative_graph" style={graphStyle}>
          <h4
            style={{
              textAlign: "left",
              color: "#000",
              fontWeight: "600",
              paddingBottom: 22,
            }}
          >
            {Strings.radcliffCumulativeSubHeading}
          </h4>
          <Spin spinning={this.state.loader}>
            <div style={{ width: "100%", height: 340 }}>
              <div style={yRotate}>
                <p style={yAxisLabelStyle}>Number of Participants</p>
              </div>
              <div className="bar-graph-cover">
                <Bar
                  data={this.state.graphData}
                  options={options}
                  style={{
                    height: "200px",
                    maxHeight: "320px",
                  }}
                />
                <p style={paraStyle}>Month - {this.state.selected_year}</p>
              </div>
              <br />
            </div>
          </Spin>
        </div>
      </div>
    );
  }
}
